<template>
  <div class="success">
    <img src="../assets/images/success-icon.png" alt="">
    <span>İşleminiz Başarılı!</span>
    <router-link :to="{ name: 'GetStarted', }">
      <span class="go-icon">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
      </span>
      BAŞA DÖN
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Success',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .success {
    margin: 50px 0;
    float: left;
    width: 100%;

    img {
      display: block;
      max-width: 100px;
      margin: 20px auto;
    }

    > span {
      color: #73C33F;
      display: block;
      text-align: center;
    }

    a {
      background-color: #2B7EED;
      width: 75%;
      display: block;
      margin: 15px auto;
      color: #fff;
      text-decoration: none;
      padding: 15px 20px;
      border-radius: 5px;

      span {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Success.vue?fe4e44c4